import { Typography } from "antd";
import styled from "styled-components";

export const MissionTermsFormat = styled(Typography.Text)`
    li {
    margin: 16px;
    line-height: 200%;
    }
`